// extracted by mini-css-extract-plugin
export default {"teamCard":"TeamCard_teamCard__CczxN","profileImgDiv":"TeamCard_profileImgDiv__1CBFx","details":"TeamCard_details__2gBM5","social":"TeamCard_social__GzwuH"};